import BasicLayout from "layouts/BasicLayout";
import WiredropDownloadPage from "pages/wiredrop-download";
import React from "react";

const WiredropDownloadRoute = () => {
	return (
		<BasicLayout>
			<WiredropDownloadPage />
		</BasicLayout>
	);
};

export default WiredropDownloadRoute;
